import React from 'react';
import type { LucideIcon } from 'lucide-react';
import clsx from 'clsx';
import Surface from './Surface';

const toneClasses = {
  blue: 'bg-primary-50 text-primary-600 dark:bg-primary-950 dark:text-primary-300',
  green:
    'bg-success-50 text-success-600 dark:bg-success-950 dark:text-success-300',
  amber:
    'bg-warning-50 text-warning-600 dark:bg-warning-950 dark:text-warning-300',
  red: 'bg-danger-50 text-danger-600 dark:bg-danger-950 dark:text-danger-300',
};

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  icon: LucideIcon;
  note?: React.ReactNode;
  tone?: keyof typeof toneClasses;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  icon: Icon,
  note,
  tone = 'blue',
}) => (
  <Surface padding='md' className='min-w-0'>
    <div className='flex items-start justify-between gap-4'>
      <div className='min-w-0'>
        <p className='truncate text-sm font-medium text-secondary-500 dark:text-secondary-400'>
          {label}
        </p>
        <p className='mt-2 text-2xl font-bold tabular-nums text-secondary-950 dark:text-white'>
          {value}
        </p>
      </div>
      <div
        className={clsx(
          'flex h-11 w-11 shrink-0 items-center justify-center rounded-xl',
          toneClasses[tone]
        )}
      >
        <Icon className='h-5 w-5' aria-hidden='true' />
      </div>
    </div>
    {note ? (
      <div className='mt-3 text-xs font-medium text-secondary-500 dark:text-secondary-400'>
        {note}
      </div>
    ) : null}
  </Surface>
);

export default MetricCard;
